module.exports = __webpack_public_path__ + "static/media/Main-banner-about.fd2b3fa1.png";